// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"428db34a","276":"1e4d7453","375":"fb5efd19","410":"e18c29a8","470":"8a6f2984","588":"93e39d23","620":"b4a66904","630":"5994f772","655":"3d5b3503","700":"04a5f544","717":"caec4a23","735":"49b0227b","823":"3d181917"}[chunkId] + ".chunk.js";
};